export default __webpack_public_path__ + "static/media/IconYellow.3ea3e2b5.svg";